<template>
  <Modal @closeModal="$emit('back')">
    <p class="bold text-xl">
      {{ $t('text.payFirstDueInvoices') }}
    </p>
    <button
      class="button mt-5"
      @click="$emit('back')"
    >
      {{ $t('text.goBack') }}
    </button>
  </Modal>
</template>

<script>
import Modal from '@/components/ui/Modal';

export default {
  name: 'PayFirstDueInvoices',

  components: { Modal }
};
</script>
